import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installBuildVersionCheck } from "@/lib/buildVersionCheck";
import { installAndroidFullscreenVideoFix } from "@/lib/androidFullscreenVideo";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// v79.21 — Auto-refresh installed Android app / open browser tabs when
// a new web build is deployed. Compares the running main.<hash>.js
// against /asset-manifest.json every 5 min + on foreground return.
// See src/lib/buildVersionCheck.js for the full rationale.
installBuildVersionCheck();
// v79.159 — Hide Capacitor status bar when a `<video>` enters
// fullscreen so the blue Android header stops blocking playback.
installAndroidFullscreenVideoFix();
